<main>
  <loading-overlay [isLoading]="isLoading > 0" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Users_Title' | translateWF: 'Users' }}</h1>
        <div class="page__title_buttons">
          <p-button label="{{ 'Add' | translateWF: 'Add' }}" icon="pi pi-plus" (onClick)="openModalUser(null)" />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12 md:col-span-3">
        @if (filterConfig(); as config) {
          <csl-dynamic-filters [filterConfig]="config" [state]="filterState" />
        }
      </div>

      <div class="col-span-12 md:col-span-9">
        <p-table [value]="listUsers() ?? []" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50, 100, 200]" selectionMode="single">
          <ng-template #header>
            <tr>
              <th>{{ 'Users_Table_Title_User' | translateWF: 'User' }}</th>
              @if (showSites()) {
                <th>{{ 'Sites' | translateWF: 'Sites' }}</th>
              }
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-user>
            <tr class="cursor-pointer">
              <td>
                {{ user.username }}
                @if (!isDelegate() && user.isExternallyManaged) {
                  <i
                    class="pi pi-users ml-2 text-primary"
                    role="img"
                    [attr.aria-label]="'Users_ExternallyManaged_Tooltip' | translateWF: 'Managed externally'"
                    [pTooltip]="'Users_ExternallyManaged_Tooltip' | translateWF: 'Managed externally'"
                    tooltipPosition="top"
                  ></i>
                }
              </td>
              @if (showSites()) {
                <td>{{ getAssignedSiteNames(user) }}</td>
              }
              <td class="!text-end">
                <div class="inline-flex gap-2">
                  @if (canResetAuthenticator()) {
                    <p-button
                      variant="outlined"
                      severity="secondary"
                      icon="pi pi-mobile"
                      [pTooltip]="'Users_ResetAuthenticator' | translateWF: 'Reset authenticator'"
                      tooltipPosition="left"
                      (onClick)="resetTarget.set(user.username)"
                    />
                  }
                  <p-button variant="outlined" icon="pi pi-pencil" (onClick)="openModalUser(user)" />
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td [attr.colspan]="showSites() ? 3 : 2">{{ 'Users_Empty' | translateWF: 'No users found' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</main>

<p-dialog
  [visible]="!!resetTarget()"
  (visibleChange)="!$event && resetTarget.set(null)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  header="{{ 'Users_ResetAuthenticator_Title' | translateWF: 'Reset authenticator?' }}"
>
  <p class="m-0 text-sm leading-relaxed">
    {{
      'Users_ResetAuthenticator_Body'
        | translateWF
          : 'The user will no longer be able to sign with their current phone and will have to set up Microsoft Authenticator again. Use this when they lost or changed their phone.'
    }}
  </p>
  <p class="mt-3 mb-0 text-sm font-semibold">{{ resetTarget() }}</p>
  <ng-template #footer>
    <p-button variant="text" label="{{ 'Cancel' | translateWF: 'Cancel' }}" (onClick)="resetTarget.set(null)" />
    <p-button severity="danger" label="{{ 'Users_ResetAuthenticator_Confirm' | translateWF: 'Reset' }}" [loading]="resetting()" (onClick)="confirmReset()" />
  </ng-template>
</p-dialog>
